import React, { useContext, useEffect } from 'react';
import { useParams } from 'next/navigation';
import Home from 'lib/UserProfile/Home';
import { NoodlePage } from '@typings/NextJS';
import UserProfileLayout, { UserProfileContext } from '@layouts/UserProfileLayout';
import { useFeatureFlag } from '@providers/FeatureFlags';
import LoggedInUserGate from '@components/Auth/LoggedInUserGate';
import { useCreatorUI } from '@providers/CreatorUI';
import UserProfile from '@lib/UserProfile';
import { NoLayout } from '@layouts';
import isInIframe from '@helpers/isInIframe';

const UserProfilePage: NoodlePage = () => {
  const pathParams = useParams<{ creatorSlug: string }>();
  const creatorSlug = pathParams?.creatorSlug;
  const isV3 = useFeatureFlag('user-profile-v3');
  const showV1UserProfile = !isV3 || isInIframe();

  const creator = useCreatorUI();
  const { setBrowserTabTitle } = useContext(UserProfileContext);

  useEffect(() => {
    setBrowserTabTitle('Your to-do list');
  }, [setBrowserTabTitle]);

  if (!creatorSlug) {
    return null;
  }

  if (!showV1UserProfile) {
    return <Home />;
  }

  return (
    <LoggedInUserGate creator={creator} isAnonymousAllowed={false}>
      <UserProfile creatorSlug={creatorSlug} />
    </LoggedInUserGate>
  );
};

UserProfilePage.Layout = NoLayout;
UserProfilePage.getLayout = page => <UserProfileLayout tab='home'>{page}</UserProfileLayout>;

export default UserProfilePage;
